import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Facebook, Instagram, Phone, Mail, MapPin } from "lucide-react";
export default function PureDetailFooter() {
  const businessName = "Pure Detail Cleaning";
  const motto = "Pure Effort. Pure Pride. Pure Detail.";
  const phone = "(512)635-9324";
  const email = "DallasD@PureDetailCleaning.com";
  const address = "Central Texas";
  const services = [{
    name: "Residential Cleaning",
    path: "/ServicesSectionPage"
  }, {
    name: "Move-In / Move-Out",
    path: "/ServicesSectionPage"
  }, {
    name: "Commercial Cleaning",
    path: "/ServicesSectionPage"
  }, {
    name: "Short-Term Rental",
    path: "/ServicesSectionPage"
  }];
  const companyLinks = [{
    name: "Home",
    path: "/HomePage"
  }, {
    name: "About Us",
    path: "/AboutPureDetailPage"
  }, {
    name: "Reviews",
    path: "/TestimonialsReviewsPage"
  }];
  const legalLinks = [{
    name: "Privacy Policy",
    path: "#"
  }, {
    name: "Terms of Service",
    path: "#"
  }, {
    name: "Cookie Policy",
    path: "#"
  }];
  const carouselImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/cleaning_result_1.png",
    alt: "Cleaning Detail 1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/cleaning_result_2.png",
    alt: "Cleaning Detail 2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/cleaning_result_3.png",
    alt: "Cleaning Detail 3"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/cleaning_result_4.png",
    alt: "Cleaning Detail 4"
  }];
  return <section id="pure-detail-footer" className="bg-gradient-to-b from-[#F9CBD6] via-[#F2AFBC] via-[#9E182B] to-[#F2E0D2] text-foreground relative overflow-hidden font-sans">
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562197/img/image_b5i58mkc.png" alt="Pure Detail Cleaning Professional Service" className="w-full h-48 md:h-64 object-cover" />
      <div className="absolute inset-0 bg-black/5 pointer-events-none z-10" />
      <div className="container mx-auto px-6 py-16 relative z-20">
        
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8 mb-16">
          <div className="shrink-0">
            
          </div>
          
        </div>

        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          
          <div>
            <h3 className="text-foreground font-bold tracking-wide mb-6 uppercase text-sm">Services</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to={service.path} className="text-sm text-foreground/70 hover:text-primary transition-colors duration-200 block font-medium">
                    {service.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          
          <div>
            <h3 className="text-foreground font-bold tracking-wide mb-6 uppercase text-sm">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="text-sm text-foreground/70 hover:text-primary transition-colors duration-200 block font-medium">
                    {link.name}
                  </Link>
                </li>)}
              <li data-index={companyLinks.length} className="pt-2">
                <Button asChild className="bg-[#B11226] hover:bg-[#8B2E3C] text-white rounded-none h-9 px-6 text-xs uppercase tracking-widest transition-all duration-300 shadow-lg shadow-primary/20">
                  <Link to="/PureDetailBookingPage">Book Now</Link>
                </Button>
              </li>
            </ul>
          </div>

          
          <div>
            <h3 className="text-foreground font-bold tracking-wide mb-6 uppercase text-sm">Contact</h3>
            <ul className="space-y-4">
              <li data-index={0} className="flex items-start gap-3 text-sm text-foreground/70 font-medium">
                <MapPin className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                <span>{address}</span>
              </li>
              <li data-index={1} className="flex items-center gap-3 text-sm text-foreground/70 font-medium">
                <Mail className="w-4 h-4 text-primary shrink-0" />
                <Link to={`mailto:${email}`} className="text-foreground font-bold hover:text-primary transition-all duration-300 decoration-primary underline-offset-4 hover:underline">
                  {email}
                </Link>
              </li>
              <li data-index={2} className="flex items-center gap-3 text-sm text-foreground/70 font-medium">
                <Phone className="w-4 h-4 text-primary shrink-0" />
                <Link to={`tel:${phone.replace(/\D/g, '')}`} className="text-foreground font-bold hover:text-primary transition-all duration-300 decoration-primary underline-offset-4 hover:underline">
                  {phone}
                </Link>
              </li>
            </ul>
          </div>

          
          <div>
            <h3 className="text-foreground font-bold tracking-wide mb-6 uppercase text-sm">Legal</h3>
            <ul className="space-y-3">
              {legalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.path} className="text-sm text-foreground/70 hover:text-primary transition-colors duration-200 block font-medium">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mb-16">
          <Carousel className="w-full max-w-5xl mx-auto">
            <CarouselContent className="-ml-4">
              {carouselImages.map((img, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="aspect-video overflow-hidden">
                    <img src={img.src} alt={img.alt} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-12 border-white/10 text-white hover:bg-white/10" />
            <CarouselNext className="hidden md:flex -right-12 border-white/10 text-white hover:bg-white/10" />
          </Carousel>
        </div>

        <Separator className="bg-white/10 mb-10" />

        
        <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-8">
          
          <div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
            <p className="text-xs text-foreground/50 font-medium">
              &copy; {new Date().getFullYear()} {businessName}. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="https://www.instagram.com/puredetailcleaning" newTab className="text-foreground/60 hover:text-primary transition-colors p-2 hover:bg-black/5 rounded-full" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </Link>
              <Link to="https://www.facebook.com/profile.php?id=61589071733300" newTab className="text-foreground/60 hover:text-primary transition-colors p-2 hover:bg-black/5 rounded-full" aria-label="Facebook">
                <Facebook className="w-4 h-4" />
              </Link>
            </div>
          </div>

          
          <div className="flex flex-col items-center lg:items-end">
            
            
            
          </div>
        </div>
      </div>

      
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[20%] w-full text-center pointer-events-none select-none opacity-[0.05] z-10">
        <span className="text-[12vw] font-bold whitespace-nowrap text-white leading-none tracking-tighter">
          {motto}
        </span>
      </div>
    </section>;
}